import { render, staticRenderFns } from "./ColorsTailwind.vue?vue&type=template&id=c873575a"
import script from "./ColorsTailwind.vue?vue&type=script&lang=js"
export * from "./ColorsTailwind.vue?vue&type=script&lang=js"
import style0 from "./ColorsTailwind.vue?vue&type=style&index=0&id=c873575a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports